import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=372f3c5c"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"
import style0 from "./Menu.vue?vue&type=style&index=0&id=372f3c5c&prod&lang=less"
import style1 from "./Menu.vue?vue&type=style&index=1&id=372f3c5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports